import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import ReactSelect from '../shared/ReactSelect';

import selectFormTheme from '../shared/ReactSelect-form.module.postcss';

function SelectInput({
  label,
  input,
  options,
  type,
  multi,
  placeholder,
  required,
  half,
  clearable,
  valueKey = 'value',
  labelKey = 'label',
  limit = 10,
  hint,
  onInputChange,
  className,
  labelClassName,
  searchable = false,
  defaultValue,
  meta: { error, warning },
  onChangeModifier,
  noFormRow = false,
  theme,
}) {
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    if (defaultValue && !input.value) {
      input.onChange(defaultValue);
    }
  }, [defaultValue, input.value, input]);

  let value = input.value ? input.value : defaultValue;
  if (!multi && options && value) {
    value = options.find((option) => {
      return option[valueKey]?.toString() === value.toString();
    });
  }

  const handleChange = (values) => {
    if (multi) {
      if (values.length <= limit) {
        input.onChange(values);
      }
    } else {
      let finalValue = values;
      if (onChangeModifier) {
        finalValue = onChangeModifier(values);
      } else if (!multi) {
        finalValue = values ? values[valueKey] : null;
      }
      input.onChange(finalValue);
    }
  };

  const handleInputChange = (newValue) => {
    setTouched(true);

    if (onInputChange) {
      onInputChange(newValue);
    }
  };

  return (
    <div
      className={
        cn({
          FormRow: !noFormRow,
          'FormRow--half': half
        }, className)
      }
    >
      { label &&
        <label
          className={cn({
            FormLabel: true,
            'FormLabel--required': required
          }, labelClassName)}
          htmlFor={input.name}
        >
          {label}
        </label>
      }

      <ReactSelect
        theme={theme || selectFormTheme}
        placeholder={placeholder || 'Select'}
        isMulti={multi || false}
        options={options}
        getOptionLabel={(option) => option[labelKey]}
        getOptionValue={(option) => option[valueKey]}
        isSearchable={searchable}
        isClearable={clearable}
        value={value}
        onChange={handleChange}
        onInputChange={handleInputChange}
      />

      { hint &&
        <div className="hint">
          {hint}
        </div>
      }

      { touched && (error || warning) &&
        <div className="ErrorExplanation">
          {touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
        </div>
      }
    </div>
  );
}

SelectInput.propTypes = {
  input: PropTypes.object,
  error: PropTypes.string,
  type: PropTypes.string,
  hint: PropTypes.string,
  required: PropTypes.bool,
  half: PropTypes.bool,
  warning: PropTypes.string,
  meta: PropTypes.object,
  onInputChange: PropTypes.func,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  multi: PropTypes.bool,
  valueKey: PropTypes.string,
  labelKey: PropTypes.string,
  limit: PropTypes.number,
  onChangeModifier: PropTypes.func,
};

export default SelectInput;
